import { Link } from '@tanstack/react-router'
import { EmailForm } from './components/EmailForm'
import { OTPForm } from './components/OTPForm'
import { useLoginViewModel } from './hooks/useLoginViewModel'

export function LoginPage() {
  const vm = useLoginViewModel()

  // Carry whatever the visitor already gave us across to signup: the email they
  // typed, and the `redirect` that gets them back to a slot they picked while
  // logged out. Both have to survive the hop or the booking is lost.
  const signupSearch = {
    ...(vm.email ? { email: vm.email } : {}),
    ...(vm.redirect ? { redirect: vm.redirect } : {}),
  }

  return (
    <div className='absolute inset-0 flex items-center justify-center px-4'>
      {vm.step === 'email' ? (
        <EmailForm
          email={vm.email}
          onEmailChange={vm.setEmail}
          onSubmit={vm.handleEmailSubmit}
          isLoading={vm.isRequestingCode}
          error={vm.error}
          errorAction={
            vm.errorKind === 'no-account' ? (
              <Link
                to='/signup'
                search={signupSearch}
                className='text-sm font-semibold text-red-800 underline hover:no-underline'
              >
                Create an account
              </Link>
            ) : undefined
          }
          footer={
            <p className='text-center text-sm text-muted-foreground'>
              New to Apptly Health?{' '}
              <Link
                to='/signup'
                search={signupSearch}
                className='font-medium text-primary hover:underline'
              >
                Create an account
              </Link>
            </p>
          }
        />
      ) : (
        <OTPForm
          otp={vm.otp}
          onOtpChange={vm.setOtp}
          onSubmit={vm.handleVerifyCode}
          onResend={vm.handleResendCode}
          onBack={vm.handleBackToEmail}
          isLoading={vm.isVerifying}
          isResending={vm.isResending}
          error={vm.error}
          notice={vm.notice}
          cooldown={vm.cooldownRemaining}
          email={vm.email}
        />
      )}
    </div>
  )
}
